import * as React from "react";
import { AdaptiveCard, defaultHostConfig } from "adaptivecards";
import { renderToString } from 'react-dom/server'
import ReactMarkdown from "react-markdown";
import rehypeRaw from 'rehype-raw'
import './AdaptiveCard.css'
import rehypeExternalLinks from "rehype-external-links";
import {useEffect} from "react";

const wrapTextBlocks = (value: unknown): unknown => {
    if (Array.isArray(value)) {
        return value.map((item) => wrapTextBlocks(item));
    }

    if (!value || typeof value !== "object") {
        return value;
    }

    const source = value as Record<string, unknown>;
    const result: Record<string, unknown> = {};

    Object.entries(source).forEach(([key, child]) => {
        result[key] = wrapTextBlocks(child);
    });

    if (result.type === "TextBlock") {
        result.wrap = true;
    }

    return result;
};

type AdaptiveCardProps = {
    card: any;
    actionHandler: (action: any) => void
};

const AdaptiveCardComponent : React.FC<AdaptiveCardProps> = ({ card, actionHandler}) => {
    const cardWrapperRef = React.createRef<HTMLDivElement>();

    useEffect(() => {
        if (!cardWrapperRef || !card || !cardWrapperRef.current) return;

        const adaptiveCard = new AdaptiveCard();
        adaptiveCard.hostConfig = defaultHostConfig;
        adaptiveCard.hostConfig.containerStyles.default.backgroundColor = "#dbdbdb";
        adaptiveCard.hostConfig.fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n" +
            "    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n" +
            "    sans-serif;"
        adaptiveCard.hostConfig.fontSizes.default = 15
        adaptiveCard.hostConfig.spacing.padding = 0
            AdaptiveCard.onProcessMarkdown = function (content, result) {
            result.outputHtml = renderToString(<ReactMarkdown rehypePlugins={[[rehypeRaw], [rehypeExternalLinks, {target: '_blank'}]]}>{content}</ReactMarkdown>)
            result.didProcess = true;
        };
        adaptiveCard.onExecuteAction = actionHandler;
        adaptiveCard.parse(wrapTextBlocks(card));

        cardWrapperRef.current.innerHTML = "";
        adaptiveCard.render(cardWrapperRef.current);
    }, [card, cardWrapperRef, actionHandler]);

    return <div ref={cardWrapperRef} className="adaptive-card-renderer" />;
};

export default AdaptiveCardComponent;
